(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-media]');
    if (!root) return;
    const thumbs = Array.from(root.querySelectorAll('[data-thumb-index]'));
    const shots = Array.from(root.querySelectorAll('[data-shot-index]'));
    const main = root.querySelector('.pdp__gallery-main');
    if (!shots.length) return;

    let active = 0;

    const show = (index) => {
      const next = Math.max(0, Math.min(shots.length - 1, index));
      active = next;
      const key = String(next);
      thumbs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('data-thumb-index') === key));
      shots.forEach((shot) => {
        shot.classList.toggle('is-active', shot.getAttribute('data-shot-index') === key);
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        show(Number(thumb.getAttribute('data-thumb-index')));
      });
    });

    if (main && shots.length > 1) {
      let startX = 0;
      let startY = 0;
      let tracking = false;
      main.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;
          startX = touch.clientX;
          startY = touch.clientY;
          tracking = true;
        },
        { passive: true }
      );
      main.addEventListener(
        'touchend',
        (event) => {
          if (!tracking) return;
          tracking = false;
          const touch = event.changedTouches[0];
          if (!touch) return;
          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
          show(active + (dx < 0 ? 1 : -1));
        },
        { passive: true }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
